<template>
    <label :class="{ 'cursor-pointer': !disabled && !readonly, disabled: disabled }">
        <input
            :disabled="disabled"
            @input="input"
            :id="id"
            :value="value"
            :type="type"
            :name="name"
            :checked="checked"
            hidden
        />
        <div
            for="active"
            class="check-box"
            :style="[square ? { 'border-radius': '4px' } : {}]"
            :class="[
                size == 'lg' ? 'big' : size == 'md' ? 'medium' : 'sm',
                theme == 'dark'
                    ? 'dark'
                    : theme == 'red'
                    ? 'red'
                    : theme == 'grey'
                    ? 'grey'
                    : theme == 'green'
                    ? 'green'
                    : 'light'
            ]"
        >
            <div class="checkmark pointer-events-none"></div>
        </div>
        <span v-if="showContent"><slot /></span>
    </label>
</template>

<script>
export default {
    name: 'XCheckbox',

    props: {
        value: {},

        type: {
            type: String,
            default: 'radio'
        },

        size: {
            type: String,
            default: 'sm'
        },

        theme: {
            type: String,
            default: 'light'
        },

        name: {
            type: String,
            default: ''
        },

        id: {
            type: String,
            default: ''
        },

        checked: {
            type: Boolean,
            default: false
        },

        disabled: {
            type: Boolean,
            default: false
        },

        readonly: {
            type: Boolean,
            default: false
        },

        square: {
            type: Boolean,
            default: false
        },

        showContent: {
            type: Boolean,
            default: true
        }
    },

    methods: {
        input(e) {
            this.$emit('input', e)
        }
    }
}
</script>

<style lang="scss" scoped>
@import '../../scss/variable.scss';

label {
    display: flex;
    align-items: center;
    column-gap: 8px;

    &.disabled {
        opacity: 0.5;
    }

    input[type='radio']:checked + .big.light,
    input[type='radio']:checked + .medium.light,
    input[type='checkbox']:checked + .big.light,
    input[type='checkbox']:checked + .medium.light {
        background-color: #fff;

        .checkmark {
            display: inline-block;
        }
    }

    input[type='radio']:checked + .big.dark,
    input[type='radio']:checked + .medium.dark,
    input[type='checkbox']:checked + .big.dark,
    input[type='checkbox']:checked + .medium.dark {
        background-color: #463e3c;

        .checkmark {
            display: inline-block;
        }
    }

    input[type='radio']:checked + .big.red,
    input[type='radio']:checked + .medium.red,
    input[type='checkbox']:checked + .big.red,
    input[type='checkbox']:checked + .medium.red {
        background-color: #dc3746;

        .checkmark {
            display: inline-block;
        }
    }

    input[type='radio']:checked + .big.grey,
    input[type='radio']:checked + .medium.grey,
    input[type='checkbox']:checked + .big.grey,
    input[type='checkbox']:checked + .medium.grey {
        background-color: #b8c2cc;

        .checkmark {
            display: inline-block;
        }
    }

    input[type='radio']:checked + .big.green,
    input[type='radio']:checked + .medium.green,
    input[type='checkbox']:checked + .big.green,
    input[type='checkbox']:checked + .medium.green {
        background-color: rgba(34, 197, 94, 1);

        .checkmark {
            display: inline-block;
        }
    }

    .check-box {
        position: relative;
        border-radius: 50%;

        &.big.light {
            width: 28px;
            height: 28px;
            border: 3px solid #fff;

            @media screen and (max-width: 767px) {
                width: 26px;
                height: 26px;
            }

            .checkmark {
                display: none;
                position: absolute;
                top: 4px;
                left: 8px;
                transform: rotate(45deg);
                height: 12px;
                width: 6px;
                border-bottom: 3px solid $input-placeholder-color;
                border-right: 3px solid $input-placeholder-color;

                @media screen and (max-width: 767px) {
                    top: 3px;
                    left: 7px;
                    height: 12px;
                    width: 6px;
                    border-bottom: 2px solid $input-placeholder-color;
                    border-right: 2px solid $input-placeholder-color;
                }
            }
        }

        &.medium.light {
            width: 16px;
            height: 16px;
            border: 1px solid #fff;

            .checkmark {
                display: none;
                position: absolute;
                top: 2px;
                left: 5px;
                transform: rotate(45deg);
                height: 9px;
                width: 4.5px;
                border-bottom: 2px solid $input-placeholder-color;
                border-right: 2px solid $input-placeholder-color;
            }
        }

        &.big.dark {
            width: 28px;
            height: 28px;
            border: 3px solid #5a5351;

            @media screen and (max-width: 767px) {
                width: 26px;
                height: 26px;
            }

            .checkmark {
                display: none;
                position: absolute;
                top: 4px;
                left: 8px;
                transform: rotate(45deg);
                height: 12px;
                width: 6px;
                border-bottom: 3px solid rgba(255, 255, 255, 0.7);
                border-right: 3px solid rgba(255, 255, 255, 0.7);

                @media screen and (max-width: 767px) {
                    top: 3px;
                    left: 8px;
                    height: 12px;
                    width: 6px;
                    border-bottom: 2px solid rgba(255, 255, 255, 0.7);
                    border-right: 2px solid rgba(255, 255, 255, 0.7);
                }
            }
        }

        &.medium.dark {
            width: 16px;
            height: 16px;
            border: 1px solid #5a5351;

            .checkmark {
                display: none;
                position: absolute;
                top: 2px;
                left: 5px;
                transform: rotate(45deg);
                height: 9px;
                width: 4.5px;
                border-bottom: 2px solid rgba(255, 255, 255, 0.7);
                border-right: 2px solid rgba(255, 255, 255, 0.7);
            }
        }

        &.big.red {
            width: 28px;
            height: 28px;
            border: 3px solid #dc3746;

            @media screen and (max-width: 767px) {
                width: 26px;
                height: 26px;
            }

            .checkmark {
                display: none;
                position: absolute;
                top: 4px;
                left: 8px;
                transform: rotate(45deg);
                height: 12px;
                width: 6px;
                border-bottom: 3px solid #fff;
                border-right: 3px solid #fff;

                @media screen and (max-width: 767px) {
                    top: 3px;
                    left: 7px;
                    height: 12px;
                    width: 6px;
                    border-bottom: 2px solid #fff;
                    border-right: 2px solid #fff;
                }
            }
        }

        &.medium.red {
            width: 16px;
            height: 16px;
            border: 1px solid #dc3746;

            .checkmark {
                display: none;
                position: absolute;
                top: 2px;
                left: 5px;
                transform: rotate(45deg);
                height: 9px;
                width: 4.5px;
                border-bottom: 2px solid #fff;
                border-right: 2px solid #fff;
            }
        }

        &.big.grey {
            width: 28px;
            height: 28px;
            border: 3px solid #b8c2cc;

            @media screen and (max-width: 767px) {
                width: 26px;
                height: 26px;
            }

            .checkmark {
                display: none;
                position: absolute;
                top: 4px;
                left: 8px;
                transform: rotate(45deg);
                height: 12px;
                width: 6px;
                border-bottom: 3px solid #fff;
                border-right: 3px solid #fff;

                @media screen and (max-width: 767px) {
                    top: 3px;
                    left: 7px;
                    height: 12px;
                    width: 6px;
                    border-bottom: 2px solid #fff;
                    border-right: 2px solid #fff;
                }
            }
        }

        &.medium.grey {
            width: 16px;
            height: 16px;
            border: 1px solid #b8c2cc;

            .checkmark {
                display: none;
                position: absolute;
                top: 2px;
                left: 5px;
                transform: rotate(45deg);
                height: 9px;
                width: 4.5px;
                border-bottom: 2px solid #fff;
                border-right: 2px solid #fff;
            }
        }

        &.big.green {
            width: 28px;
            height: 28px;
            border: 3px solid rgba(34, 197, 94, 1);

            @media screen and (max-width: 767px) {
                width: 26px;
                height: 26px;
            }

            .checkmark {
                display: none;
                position: absolute;
                top: 4px;
                left: 8px;
                transform: rotate(45deg);
                height: 12px;
                width: 6px;
                border-bottom: 3px solid #fff;
                border-right: 3px solid #fff;

                @media screen and (max-width: 767px) {
                    top: 3px;
                    left: 8px;
                    height: 12px;
                    width: 6px;
                    border-bottom: 2px solid #fff;
                    border-right: 2px solid #fff;
                }
            }
        }

        &.medium.green {
            width: 16px;
            height: 16px;
            border: 1px solid #5a5351;

            .checkmark {
                display: none;
                position: absolute;
                top: 2px;
                left: 5px;
                transform: rotate(45deg);
                height: 9px;
                width: 4.5px;
                border-bottom: 2px solid rgba(255, 255, 255, 0.7);
                border-right: 2px solid rgba(255, 255, 255, 0.7);
            }
        }
    }
}
</style>
